import styled from '@emotion/styled';

export const AccountDetailsContainer = styled.div`
  width: 100%;
  max-width: 700px;
  margin-inline: auto;
`;
